"use client"

import { PanelBottomDashed } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `PanelBottomDashedIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const PanelBottomDashedIcon = component(Icon)({ as: PanelBottomDashed })
